import groupListNodesViewStateStore from '../store/groupListNodesViewStateStore';
import { GroupFolderTreeViewState } from '../store/schema/GroupFolderTreeViewState';

export function getGroupViewState(groupId: string): GroupFolderTreeViewState | null {
    if (groupId) {
        const groupViewState = groupListNodesViewStateStore.groupListNodesViewStates.get(
            groupId.toLowerCase()
        );
        return groupViewState ?? null;
    }

    return null;
}
